
export { GGUSection } from "/codebuild/output/src3223353080/src/packages/shared-components/src/campaign/GGUSection.tsx"